import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (!data?.name?.length > 0)
        response.push(<Box>Digite o nome do serviço.</Box>)
    if (!data?.value?.length > 0)
        response.push(<Box>Digite um valor.</Box>)
    if (data.documents.length === 0)
        response.push(<Box>Selecione um documento.</Box>)
    if (data.plagues.length === 0)
        response.push(<Box>Selecione um item.</Box>)
    if (response.length === 0)
        return ''

    return (response)
}

export default validateData